enum ProcessStatus {
  Complete = 'COMPLETE',
  Active = 'ACTIVE',
}

export default ProcessStatus;
